export const initialState = {
    name: '',
    phone: '',
    message: '',
    sending: false,
    sended: false
};